import { Slot } from "@radix-ui/react-slot";
import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import clsx from "clsx";
import * as React from "react";

const buttonVariants = cva(
	"inline-flex items-center justify-center  whitespace-nowrap  text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
	{
		variants: {
			variant: {
				default: "bg-primary text-primary-foreground hover:bg-primary/70",
				destructive: "text-destructive-foreground bg-destructive hover:bg-destructive/90",
				outline: "border border-primary bg-background text-primary hover:bg-accent ",
				ghostOutline: "border bg-background text-gray-700 hover:bg-accent ",
				secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
				ghost: "",
				// ghost: 'hover:bg-accent hover:text-accent-foreground',
				link: "text-primary underline-offset-4 hover:underline",
			},
			size: {
				default: "h-10 px-4 py-2",
				sm: "h-9 rounded-md px-3",
				lg: "h-11 rounded-md px-8",
				none: "",
				icon: "size-10",
			},
		},
		defaultVariants: {
			variant: "default",
			size: "default",
		},
	},
);

interface ButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement>,
		VariantProps<typeof buttonVariants> {
	asChild?: boolean;
	rounded?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
	({ className, rounded, variant, size, asChild = false, ...props }, ref) => {
		const Comp = asChild ? Slot : "button";
		return (
			<Comp
				ref={ref}
				className={clsx(
					rounded ? "rounded-full" : "rounded-md",
					buttonVariants({ variant, size, className }),
				)}
				{...props}
			/>
		);
	},
);
Button.displayName = "Button";

export default Button;
